import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import Button from '../Button/Button.js';
import MenuUfficiItems from './MenuUfficiItems.js';
import MeetingRoom from '../../GoogleIcons/Outlined/MeetingRoom.js';
import NavigateNextIcon from '../../GoogleIcons/Outlined/NavigateNextIcon.js';
import NavDropdown from '../../NavDropdown/NavDropdown.js';

function MenuUffici({ uffici = [], ufficioSelezionato = undefined, onUfficioChange, }) {
    const ufficiOrdered = useMemo(() => (uffici || []).sort(), [uffici]); // NOSONAR
    return ufficiOrdered.length > 3
        ? (jsx(NavDropdown.SubMenu, { title: (jsxs(Button, { className: "v2-menu-utente__uffici-btn", children: [jsx(MeetingRoom, {}), ' ', "Cambia ufficio", ' ', jsx(NavigateNextIcon, {})] })), children: jsx(MenuUfficiItems, { uffici: ufficiOrdered, ufficioSelezionato: ufficioSelezionato, onUfficioChange: onUfficioChange }) }))
        : (jsx(MenuUfficiItems, { uffici: ufficiOrdered, ufficioSelezionato: ufficioSelezionato, onUfficioChange: onUfficioChange }));
}

export { MenuUffici as default };
